<template>
    <v-container>
         <v-card tile >
            <v-card-title>แก้ไขข้อมูล วัสดุสิ้นเปลือง</v-card-title>
            <v-divider></v-divider>
            <v-container>
                <v-form ref="form" >
                <v-row>
                    <!--<v-col> <v-text-field disabled outlined v-model="mainData.consumableType" label="ประเภทวัสดุ"></v-text-field></v-col> -->
                    <v-col><v-text-field disabled outlined v-model="mainData.consumableCode" label="หมายเลขวัสดุ"></v-text-field></v-col>
                    <v-col>
                        <v-text-field disabled outlined v-model="mainData.consumableName" label="รายการวัสดุ"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    
                    <v-col><v-text-field v-model="mainData.price" outlined disabled label="ราคา"></v-text-field></v-col>
                    <v-col><v-text-field v-model="mainData.unitPrice" outlined disabled label="ราคา/หน่วย"></v-text-field></v-col>
                    <v-col><v-text-field v-model="mainData.unitOfPrice" outlined disabled label="หน่วย"></v-text-field></v-col>
                    <v-col><v-text-field v-model="mainData.stockRemain" outlined disabled label="จำนวนปัจจุบัน"></v-text-field></v-col>
                </v-row>
                <v-row>
                    <v-col>
                         <v-radio-group v-model="transType"  row>
                            <v-radio label="เพิ่ม" value="1"></v-radio>
                            <v-radio label="ลด" value="0"></v-radio>
                         </v-radio-group>
                    </v-col>
                    <v-col>
                        <v-text-field  autofocus :rules="[rules.validateTransType(transType, mainData.stockRemain)]" outlined v-model="newQty" label="จำนวน"></v-text-field>
                    </v-col>
                    <v-col><v-text-field v-model="remain" outlined disabled label="คงเหลือ"></v-text-field></v-col>
                    <v-spacer></v-spacer>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field textarea rows="2" outlined v-model="mainData.remark" label="หมายเหตุ"></v-text-field>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row class="ma-5">
                    <v-col>
                        <v-data-table
                            :headers="headers"
                                :items-per-page="15"
                                :items="history"
                            >
                        </v-data-table>
                    </v-col>
                </v-row>
                </v-form>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" >บันทึก</v-btn>
                <v-btn color="primary" @click="close">ยกเลิก</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>    
</template>


<style scoped>
    .col-header {
        background: indigo;
        color: indigo;
    }
</style>


<script>
import {updateStockConsumable} from '@/api/stock/stock-consumable-api.js'
import rules from '@/assets/js/rules.js'
import numeral from 'numeral'

export default {
    name: 'EditConsumable',
    props: ["mainData"],
    computed: {
        remain() {
            if (this.newQty == 0) return this.mainData.stockRemain;
            let remain = 0;
            if (this.transType == "1") {
                remain = parseFloat(this.mainData.stockRemain) + (parseFloat(this.newQty));
            } else {
                if (this.newQty > this.mainData.stockRemain) {
                    return this.mainData.stockRemain;
                }
                remain = parseFloat(this.mainData.stockRemain) - (parseFloat(this.newQty));
            }
            return numeral(remain).format('0.00');
        },
        currentQty() {
            if (this.newQty == 0) return this.mainData.stockRemain;
            let qty = 0;
            if (this.transType == "1") {
                qty = parseFloat(this.mainData.stockRemain) + (parseFloat(this.newQty));
            } else {
                qty = parseFloat(this.mainData.stockRemain) - (parseFloat(this.newQty));
            }
            return numeral(qty).format('0.00');
        }
    },
    watch: {
        transType() {
            this.newQty = 0;
            console.log(this.mainData.stockRemain);
        },
   } ,
    data: () => ({
        transType: '1',
         newQty: 0,
         headers: [
            {text: 'วันที่ทำรายการ', value: 'transDatetime'},
            {text: 'เลขที่ใบรับของ', value: 'receiveNo'},
            {text: 'ทะเบียนรถ', value: 'licenseNo'},
            {text: 'จำนวนรับเข้า', value: 'incomeDisplay'},
            {text: 'จำนวนเบิกออก', value: 'outgoingDisplay'},
            {text: 'ผู้ทำรายการ', value: 'updateUser'},
            {text: 'หมายเหตุ', value: 'remark'},
        ],
        history: [],
        rules: rules,
    }),
    methods: {
        save() {
            if (!this.$refs.form.validate()) {
                return;
            }

            this.mainData.qty = parseFloat(this.newQty);
            this.mainData.transType = this.transType;
            console.log(this.mainData);
            updateStockConsumable(this.mainData).then(() => {
                this.close();
            })
        },
        close() {
            this.$emit("closeDialog");
            this.newQty = 0;
            this.transType = "1";
        },
        setHistory(data) {
            this.history = data;
            if (this.history) {
                this.history.forEach(e => {
                    e.incomeDisplay = numeral(e.income).format('0,0.00');
                    e.outgoingDisplay = numeral(e.outgoing).format('0,0.00');
                });
            }
        }
    },
    mounted() {
        this.transType = this.mainData.transType;
    }
}
</script>